import { useState, useEffect } from "react";
import { Col, Row, Alert } from "react-bootstrap";
import axios from "axios";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // "sending" | "error" | "success"
  const [message, setMessage] = useState("");

  const clearFields = () => setEmail("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) return;

    setStatus("sending");

    try {
      const response = await axios.post(
        "https://api.brevo.com/v3/smtp/email",
        {
          sender: {
            name: process.env.REACT_APP_BREVO_SENDER_NAME,
            email: process.env.REACT_APP_BREVO_SENDER_EMAIL,
          },
          to: [{ email }],
          templateId: parseInt(process.env.REACT_APP_BREVO_NEWSLETTER_TEMPLATE_ID),
          params: {
            email, // or any dynamic params used in your template
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "api-key": process.env.REACT_APP_BREVO_API_KEY,
          },
        }
      );

      setStatus("success");
      setMessage("Subscribed successfully!");
      clearFields();
    } catch (error) {
      setStatus("error");
      setMessage("Subscription failed. Try again.");
    }
  };

  return (
    <Col lg={12}>
      <div className="newsletter-bx wow slideInUp">
        <Row>
          <Col lg={12} md={6} xl={5}>
            <h3>
              Subscribe to our Newsletter<br /> & Never miss latest updates
            </h3>
            {status === "sending" && <Alert>Sending...</Alert>}
            {status === "error" && <Alert variant="danger">{message}</Alert>}
            {status === "success" && <Alert variant="success">{message}</Alert>}
          </Col>
          <Col md={6} xl={7}>
            <form onSubmit={handleSubmit}>
              <div className="new-email-bx">
                <input
                  type="email"
                  value={email}
                  placeholder="Email Address"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit">Submit</button>
              </div>
            </form>
          </Col>
        </Row>
      </div>
    </Col>
  );
};
